import { render, staticRenderFns } from "./editAppInPlatformGroup.vue?vue&type=template&id=6d959f0a&scoped=true&"
import script from "./editAppInPlatformGroup.vue?vue&type=script&lang=js&"
export * from "./editAppInPlatformGroup.vue?vue&type=script&lang=js&"
import style0 from "./editAppInPlatformGroup.vue?vue&type=style&index=0&id=6d959f0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d959f0a",
  null
  
)

export default component.exports